var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScream = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 79,
    viewBox: "0 0 140 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9641_824",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 79
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 78.2609,
    rx: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9641_824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.913 88.6955C139.366 88.6955 160 68.0617 160 42.6086C160 17.1554 139.366 -3.47839 113.913 -3.47839C88.4601 -3.47839 67.8263 17.1554 67.8263 42.6086C67.8263 50.909 70.0206 58.6969 73.8608 65.4239",
    stroke: "#ECB600",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.937 13.7469C105.075 11.4116 97.3236 11.5344 92.3771 14.7143",
    stroke: "#7F39FA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.151 24.2897C144.771 20.0871 137.723 16.8569 131.889 17.5944",
    stroke: "#7F39FA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.681 68.3823C120.717 75.7089 113.787 80.0094 107.367 78.2889C100.946 76.5685 97.0943 69.3791 99.0574 62.0525C101.021 54.7259 107.951 50.4255 114.372 52.1459C120.792 53.8664 124.644 61.0557 122.681 68.3823Z",
    stroke: "#7F39FA",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.127 26.9818L91.3043 40.5369",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.493 43.1709L93.9383 24.3478",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.302 33.0687L123.478 46.6238",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.667 49.2578L126.112 30.4347",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9641_824)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 137.5,
    height: 75.7609,
    rx: 6.75,
    stroke: "#7F39FA",
    strokeWidth: 2.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9641_824",
    x: -11,
    y: -11,
    width: 162,
    height: 100.261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9641_824"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.498039 0 0 0 0 0.223529 0 0 0 0 0.980392 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9641_824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9641_824",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScream);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scream.99910835b8c487c67c9dfe8dc4e961d4.svg";